import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@primer/css/dist/base.css';
import './styles/global.css';
import { App } from './App';

const root = document.getElementById('root');

if (!root) {
  throw new Error('IssueMint root element was not found.');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
